<template>
    <v-container fluid>
        <v-dialog v-model="plannedTaskPhaseListDialog" scrollable persistent>
            <PlannedTaskPhaseList
                :key="plannedTaskPhaseListComponentKey"
                ref="plannedTaskPhaseListRef"
                :title="plannedTaskPhaseListDialogTitle"
                :selectedPlanFolderID="selectedPlanFolderID"
                :selectedPlanFolderName="selectedPlanFolderName"
                :totalSpaceM2="selectedSectionSpaceM2"
                :initSelectedYear="selectedYear"
                :initSelectedWeek="selectedWeek"
                :initSelectedGreenhouseId="selectedGreenhouseId"
                :initSelectedGreenhouseDepartmentId="
                    selectedGreenhouseDepartmentId
                "
                :initSelectedGreenhouseDepartmentSectionId="
                    selectedGreenhouseDepartmentSectionId
                "
                :initSelectedIsSalePhase="selectedIsSalePhase"
                v-on:onPlannedTaskCreated="onPlannedTaskCreated()"
                v-on:onPlannedTaskDeleted="onPlannedTaskDeleted()"
                v-on:onClosePlannedTaskPhaseList="
                    closeSectionplannedTaskPhaseListDialog()
                "
            ></PlannedTaskPhaseList>
        </v-dialog>

        <v-row v-for="section in sectionList" :key="section.id">
            <v-col cols="12">
                <v-hover>
                    <template v-slot="{ hover }">
                        <v-card :elevation="hover ? 6 : 3">
                            <!-- header -->
                            <v-row class="px-8 pt-3">
                                <v-spacer></v-spacer>
                                <span class="title">{{ section.name }}</span>
                                <span class="caption ml-2 pt-2"
                                    >({{ section.spaceM2 }} m2)
                                </span>
                                <v-spacer></v-spacer>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            small
                                            outlined
                                            color="primary"
                                            v-on="on"
                                            @click="
                                                openPlannedTaskPhaseListDialog(
                                                    section
                                                )
                                            "
                                        >
                                            <v-icon>list</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>View plan list</span>
                                </v-tooltip>
                            </v-row>
                            <!-- chart -->
                            <div class="px-3 pt-0">
                                <v-row align="center" class="mx-0">
                                    <v-col cols="12" class="pt-0">
                                        <div id="chart">
                                            <apexchart
                                                type="bar"
                                                height="200"
                                                :options="section.chartOptions"
                                                :series="section.series"
                                                v-on:section-week-selected="
                                                    onChartWeekSelected
                                                "
                                            ></apexchart>
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>

                            <slot name="footer"></slot>
                        </v-card>
                    </template>
                </v-hover>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
// import gql from "graphql-tag";
import VueApexCharts from "vue-apexcharts";
import PlannedTaskPhaseList from "@/components/planner/PlannedTaskPhaseList.vue";

export default {
    name: "section-planned-space-chart-list",
    components: {
        apexchart: VueApexCharts,
        PlannedTaskPhaseList: PlannedTaskPhaseList
    },
    props: [
        "greenhouseDepartmentSectionSet",
        "selectedYear",
        "selectedPlanFolderID",
        "selectedPlanFolderName"
    ],
    data() {
        return {
            plannedTaskPhaseListDialog: false,
            plannedTaskPhaseListComponentKey: 0,

            plannedTaskPhaseListDialogTitle: null,
            selectedSectionSpaceM2: null,
            selectedWeek: null,
            selectedGreenhouseId: null,
            selectedGreenhouseDepartmentId: null,
            selectedGreenhouseDepartmentSectionId: null,
            selectedIsSalePhase: null,

            defaultChartOptions: {
                // chart: {
                //     id: "greenhouse-department-section-space-chart",
                //     type: "bar",
                //     height: 200,
                //     stacked: true,
                //     toolbar: {
                //         show: false
                //     },
                //     events: {
                //         dataPointSelection: (event, chartContext, config) => {
                //             console.log(event, chartContext, config);

                //             this.$emit(
                //                 "week-selected",
                //                 config.seriesIndex,
                //                 config.dataPointIndex + 1
                //             );
                //         }
                //     },
                //     animations: {
                //         enabled: false
                //     }
                // },
                xaxis: {
                    // tickPlacement: 'on',
                    categories: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        24,
                        25,
                        26,
                        27,
                        28,
                        29,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39,
                        40,
                        41,
                        42,
                        43,
                        44,
                        45,
                        46,
                        47,
                        48,
                        49,
                        50,
                        51,
                        52,
                        53
                    ]
                },
                yaxis: {
                    labels: {
                        formatter: function(val) {
                            return val.toFixed(0);
                        }
                    },
                    title: {
                        text: "m2"
                    },
                    max: 2000 //default value, will be updated by greenhouse total space
                },
                fill: {
                    opacity: 1
                },
                dataLabels: {
                    enabled: false
                },
                colors: ["#00E396", "#FEB018"],
                legend: {
                    position: "top",
                    horizontalAlign: "left",
                    offsetX: 0,
                    offsetY: 0
                }
            }
        };
    },
    computed: {
        sectionList() {
            if (!this.greenhouseDepartmentSectionSet) {
                return [];
            }

            var _sectionList = this.greenhouseDepartmentSectionSet.edges.map(
                section => {
                    //// get section chart series
                    const _growingSpaceArray = this.defaultChartOptions.xaxis.categories.map(
                        item => {
                            const a = section.node.greenhouseDepartmentSectionPlannedSpaceSet.edges.find(
                                e => {
                                    return e.node.taskWeek == item;
                                }
                            );

                            return a ? a.node.growthSpaceM2 : 0;
                        }
                    );

                    const _salesSpaceArray = this.defaultChartOptions.xaxis.categories.map(
                        item => {
                            const a = section.node.greenhouseDepartmentSectionPlannedSpaceSet.edges.find(
                                e => {
                                    return e.node.taskWeek == item;
                                }
                            );

                            return a ? a.node.salesSpaceM2 : 0;
                        }
                    );

                    const _series = [
                        { name: "Growing", data: _growingSpaceArray },
                        { name: "Sales", data: _salesSpaceArray }
                    ];

                    //// get section chartOptions

                    // find max space value
                    var _totalSpaceArray = this.defaultChartOptions.xaxis.categories.map(
                        item => {
                            return (
                                _growingSpaceArray[item - 1] +
                                _salesSpaceArray[item - 1]
                            );
                        }
                    );

                    const _maxSeriesValue = Math.max(
                        ..._totalSpaceArray,
                        section.node.spaceM2
                    );

                    const _chartOptions = {
                        ...this.defaultChartOptions,
                        chart: {
                            id:
                                "greenhouse-department-section-space-chart-" +
                                section.node.id,
                            type: "bar",
                            height: 200,
                            stacked: true,
                            toolbar: {
                                show: false
                            },
                            events: {
                                dataPointSelection: (
                                    event,
                                    chartContext,
                                    config
                                ) => {
                                    this.onChartWeekSelected(
                                        section.node,
                                        config.seriesIndex,
                                        config.dataPointIndex + 1
                                    );
                                }
                            },
                            animations: {
                                enabled: false
                            }
                        },
                        ...{
                            annotations: {
                                yaxis: [
                                    {
                                        y: section.node.spaceM2, //default value, will be updated by greenhouse total space
                                        borderColor: "#eb4034",
                                        label: {
                                            borderColor: "#eb4034",
                                            style: {
                                                color: "#fff",
                                                background: "#eb4034"
                                            },
                                            text: "100%"
                                        }
                                    }
                                ]
                            }
                        },
                        ...{
                            yaxis: {
                                labels: {
                                    formatter: function(val) {
                                        return val.toFixed(0);
                                    }
                                },
                                title: {
                                    text: "m2"
                                },
                                max: _maxSeriesValue //default value, will be updated by greenhouse total space
                            }
                        }
                    };

                    return {
                        id: section.node.id,
                        name: section.node.name,
                        spaceM2: section.node.spaceM2,
                        series: _series,
                        chartOptions: _chartOptions
                    };
                }
            );

            return _sectionList;
        }
    },
    watch: {},
    methods: {
        onPlannedTaskCreated() {
            // refresh phase list
            // this.getSectionPlannedTaskPhases(this.selectedSection);

            // refresh section charts
            this.$emit("onPlannedTaskCreated");
        },
        onPlannedTaskDeleted() {
            // refresh phase list
            // this.getSectionPlannedTaskPhases(this.selectedSection);

            // refresh section charts
            this.$emit("onPlannedTaskDeleted");
        },

        // open dialog by click chart
        onChartWeekSelected(section, serialIndex, week) {
            this.plannedTaskPhaseListDialogTitle = section.name;
            this.selectedSectionSpaceM2 = section.spaceM2;
            this.selectedGreenhouseDepartmentSectionId = section.id;
            this.selectedWeek = week;
            this.selectedIsSalePhase = serialIndex == 0 ? false : true;

            // force vue rerender component
            this.plannedTaskPhaseListComponentKey += 1;
            // show dialog
            this.plannedTaskPhaseListDialog = true;
        },

        // open dialog by click right top button
        openPlannedTaskPhaseListDialog(section) {
            this.plannedTaskPhaseListDialogTitle = section.name;
            this.selectedSectionSpaceM2 = section.spaceM2;
            this.selectedGreenhouseDepartmentSectionId = section.id;
            this.selectedWeek = null;
            this.selectedIsSalePhase = null;

            // update component key to force vue rerender component
            this.plannedTaskPhaseListComponentKey += 1;
            this.plannedTaskPhaseListDialog = true;
        },

        closeSectionplannedTaskPhaseListDialog() {
            this.plannedTaskPhaseListDialog = false;
        }
    }
};
</script>